(() => {
  if (window.__awkNavigationPrefetchBound) return;
  window.__awkNavigationPrefetchBound = true;

  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;

  const prefetched = new Set();
  const maxPrefetches = 4;

  const getUrl = (anchor) => {
    if (!(anchor instanceof HTMLAnchorElement) || !anchor.href || anchor.target === '_blank' || anchor.hasAttribute('download')) return null;

    const url = new URL(anchor.href, window.location.href);
    if (url.origin !== window.location.origin || url.href === window.location.href) return null;
    if (!/^\/(products|collections)\//.test(url.pathname)) return null;

    url.hash = '';
    return url;
  };

  const prefetch = (anchor) => {
    if (prefetched.size >= maxPrefetches) return;

    const url = getUrl(anchor);
    if (!url || prefetched.has(url.href)) return;

    prefetched.add(url.href);
    const hint = document.createElement('link');
    hint.rel = 'prefetch';
    hint.as = 'document';
    hint.href = url.href;
    hint.fetchPriority = 'low';
    document.head.appendChild(hint);
  };

  const warmedImages = new Set();
  const imageWarmers = [];
  const productImageWidths = [360, 480, 540, 640, 760, 980, 1200, 1600];

  const warmProductImage = (anchor) => {
    const url = getUrl(anchor);
    if (!url || !url.pathname.startsWith('/products/')) return;

    const card = anchor.closest('product-card, [data-product-id], .product-grid__item');
    const sourceImage = card?.querySelector('.card-gallery img, .product-media__image, img');
    if (!(sourceImage instanceof HTMLImageElement)) return;

    const requiredWidth = Math.ceil(window.innerWidth * 0.88 * Math.min(window.devicePixelRatio || 1, 3));
    const targetWidth =
      productImageWidths.find((width) => width >= requiredWidth) ||
      productImageWidths[productImageWidths.length - 1];

    const source = sourceImage.currentSrc || sourceImage.src;
    if (!source) return;

    const imageUrl = new URL(source, window.location.href);
    imageUrl.searchParams.set('width', String(targetWidth));
    if (warmedImages.has(imageUrl.href)) return;

    warmedImages.add(imageUrl.href);
    const warmer = new Image();
    warmer.decoding = 'async';
    warmer.fetchPriority = 'high';
    warmer.src = imageUrl.href;
    imageWarmers.push(warmer);

    if (imageWarmers.length > 2) imageWarmers.shift();
  };

  const handleIntent = (event) => {
    const target = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!target) return;

    prefetch(target);
    warmProductImage(target);
  };

  document.addEventListener('pointerover', handleIntent, { passive: true, capture: true });
  document.addEventListener('focusin', handleIntent, true);
  document.addEventListener('touchstart', handleIntent, { passive: true, capture: true });

  const idle = window.requestIdleCallback || ((callback) => window.setTimeout(callback, 600));
  window.addEventListener(
    'load',
    () => {
      idle(
        () => {
          const selector = document.body.classList.contains('template-collection')
            ? '.awk-collection-results .product-card__link'
            : document.body.classList.contains('template-product')
              ? '.product-recommendations a[href*="/products/"]'
              : 'main a[href*="/collections/"]';

          Array.from(document.querySelectorAll(selector)).slice(0, 2).forEach(prefetch);
        },
        { timeout: 2200 }
      );
    },
    { once: true }
  );
})();
